module.exports = __webpack_public_path__ + "static/media/material_10y_y-1.880974e9.csv";